import { Box } from '@mui/material';
import React from 'react';
import { MultipleChoiceToggle } from '../MultipleChoiceToggle';
const Funding_Strategies = [
    {
        value: 'noFormalPlan',
        label: 'No formal plan',
        description: 'We do not currently have funding pipeline but know we need one. ',
    },
    {
        value: 'loosePlan',
        label: 'Loose plan ',
        description: 'We have a high level plan, but it needs more work to become actionable.',
    },
    {
        value: 'havePlan',
        label: 'Have a plan',
        description: 'Have a plan & understand how grants fit into, but need grant options',
    },
];
export const FundingStrategyField = ({ currentValue, handleFormValues, }) => {
    return (React.createElement(Box, { mb: 3 },
        React.createElement(MultipleChoiceToggle, { name: "fundingStrategy", options: Funding_Strategies, selectedOption: currentValue, handleFormValues: handleFormValues, question: "Which best describes your organization\u2019s funding strategy?" })));
};
